import React, { createContext, useContext, useMemo } from 'react';
import { gEnums } from '../../enums/globalEnums';
import { ParentContext } from './ParentContext';
import { GolfLayout, SportsDistrictLayout, SportsOrganizationLayout, SportsSeasonLayout } from './SportsSeasonLayout';

// GOOD TO GO
// const GolfTournamentProvider = React.lazy(() => import('../../../projectSpecific/golf/cnr/contexts/GolfTournamentContext'));

/** AppContext */
export const PageComponentContext = createContext();

const PageComponentProvider = (props) => {

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state, paps_state } = states ?? {}
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {})

  const { pathViews } = paps_state ?? {}
  const { organizations: organizationsKey, districts: districtsKey, sports: sportsKey } = pathViews ?? {}

  const children = useMemo(() => props.children, [props.children])

  const component_content = useMemo(() => {
    const pv = _.findLast(_.keys(pathViews), (pv) => {
      return _.get(aps_viewItems, [pv, 'pageSettings', 'useComponentContent']) &&
        _.get(aps_viewItems, [pv, 'pageSettings', 'componentContent'])
    })
    return pv ? _.get(aps_viewItems, [pv, 'pageSettings', 'componentContent']) : null
  }, [pathViews, aps_viewItems])


  const renderedProvider = useMemo(() => {

    if (!component_content) {
      return (
        <PageComponentContext.Provider value={{}}>
          {children}
        </PageComponentContext.Provider>
      )
    }

    switch (component_content) {

      case gEnums.componentContentTypes.golfTournament:
        return (
          <GolfLayout>
            {children}
          </GolfLayout>
        )

      case gEnums.componentContentTypes.sportsOrganization:
        return (
          <SportsOrganizationLayout organizationsKey={organizationsKey}>
            {children}
          </SportsOrganizationLayout>
        )

      case gEnums.componentContentTypes.sportsDistrict:
        return (
          <SportsDistrictLayout organizationsKey={organizationsKey} districtsKey={districtsKey} >
            {children}
          </SportsDistrictLayout>
        )

      case gEnums.componentContentTypes.sportsSeason:
        return (
          <SportsSeasonLayout organizationsKey={organizationsKey} districtsKey={districtsKey} sportsKey={sportsKey}>
            {children}
          </SportsSeasonLayout>
        )

      default:
        return children
    }

  }, [
    component_content
  ])

  return renderedProvider
}

export default PageComponentProvider